export const BASE_URL = "https://api.medtechdata.us/api";

/** localStorage key for cached agency object (login + GET /agency/profile) */
export const AGENCY_PROFILE_STORAGE_KEY = "agency_profile";

export const COMMON_HEADERS = {
  "Content-Type": "application/json",
  "accept": "*/*",
};

export const AGENCY_JSON_API_BASE =
  typeof process !== "undefined" && process.env.NEXT_PUBLIC_AGENCY_JSON_API_BASE
    ? process.env.NEXT_PUBLIC_AGENCY_JSON_API_BASE.replace(/\/$/, "")
    : "https://dataset-to-api-backend.vercel.app";

export const formatDateTime = (date: string | number | Date) =>
  new Date(date).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });